import { Component, OnInit } from '@angular/core';
import { CommonMessageService } from 'src/app/services/common-message.service';
import Swal from 'sweetalert2';
import { MasterDataService } from '../../services/master-data.service';

@Component({
  selector: 'app-know-your-clients',
  templateUrl: './know-your-clients.component.html',
  styleUrls: ['./know-your-clients.component.css']
})
export class KnowYourClientsComponent implements OnInit {
  selectClientName;
  clientList;
  clientDetail;
  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.selectClientName = "";
    this.getClientDetails();
  }

  getClientDetails() {
    var limit = 1000;
    var page = 0;
    this.masterDataService
      .getClients(page, limit)
      .subscribe((res: any) => {
        console.log(res);
        this.clientList = res;
        console.log('client list', this.clientList);
      });
  }

  onClientSelect() {
    this.clientDetail = null;
  }

  getClientReport() {
    console.log('client name', this.selectClientName)
    if (this.selectClientName == "" || this.selectClientName == undefined || this.selectClientName == null) {
      this.commonMessageService.swalAlertWithoutIcon('','Please select employee name');
    } else {
      this.masterDataService.getClientDetails(this.selectClientName.id).subscribe((res: any) => {
        this.clientDetail = res.client;
        console.log('report list', this.clientDetail);
      });
    }
  }
}
